import { createSelector } from '@reduxjs/toolkit'

export const draftQuestion = createSelector(
  (state) => state.eTesting,
  (state) => state.questions.map((item) => item.key)
)
